import { HttpClient, HttpParams, HttpResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { map, Observable, of } from 'rxjs';
import { FunctionAppSlot } from '../interfaces/function-app-slot.interface';
import { LinkSchedulerInformation } from '../interfaces/link-scheduler-information.interface';
import { Link } from '../interfaces/link.interface';
import { CspActivityLog } from '../interfaces/csp-activity-log.interface';

@Injectable({
	providedIn: 'root',
})
export class LinkService {
	readonly url: string = 'link';

	constructor(private http: HttpClient) {}

	public get(id: number): Observable<Link> {
		return this.http.get<Link>(this.url + '/' + id);
	}

	public getAll(): Observable<Link[]> {
		return this.http.get<Link[]>(this.url + '/' + 'GetAll');
	}

	public getByCompanyId(companyId: number): Observable<Link[]> {
		return this.http.get<Link[]>(this.url + '/getLinksFromCompany/' + companyId);
	}

	public deleteLink(linkID: number) {
		return this.http.post(this.url + '/deleteLink', linkID);
	}

	public createLink(LinkInfoId: number) {
		return this.http.get<number>(this.url + '/createFromMarketplace' + '/' + LinkInfoId);
	}

	public postSetup(setupForm: any) {
		return this.http.post(this.url + '/updateFromSetup', setupForm);
	}

	public autoSave(result: any) {
		return this.http.post(this.url + '/autoSave', result);
	}

	public getLinkSchedulerInformation(linkId: number, retrieveAllSchedules: boolean): Observable<LinkSchedulerInformation[]> {
		const params = new HttpParams().set('linkId', linkId.toString()).set('retrieveAllSchedules', retrieveAllSchedules.toString());

		return this.http.get<LinkSchedulerInformation[]>(this.url + '/linkSchedulerInformation', { params });
	}

	public runLink(LinkID: number) {
		let ownParams = new HttpParams();

		ownParams = ownParams.set('linkID', LinkID.toString());

		return this.http.get('function/triggerFunction', { params: ownParams });
	}

	public getLinkLastExecutionDate(LinkId: number): Observable<Date> {
		return this.http.get<Date>(this.url + '/getLastExecution/' + LinkId);
	}

	public getFunctionAppInstances(): Observable<FunctionAppSlot[]> {
		return this.http.get<FunctionAppSlot[]>('function/GetAllSlotStatuses');
	}

	public GetFunctionAppInstanceHistory(linkId: string, instanceId: string): Observable<string> {
		let historyParams = new HttpParams();

		historyParams = historyParams.set('linkId', linkId);
		historyParams = historyParams.set('instanceId', instanceId);

		return this.http.get<string>('function/GetInstanceHistory', { params: historyParams });
	}

	public getAdminLinkInfoReport() {
		return this.http.get(this.url + '/adminLinkIssueReport');
	}

	public getActivityLogs(linkId: number) {
		return this.http.get<CspActivityLog[]>(this.url + '/getActivityLogs?linkId=' + linkId).pipe(map(ls => {
			for(const l of ls) {
				l.loadedDate = new Date(l.loadedDate);
				l.loadedEndDate = new Date(l.loadedEndDate);
				l.creationDate += 'Z';
			}
			return ls;
		}));
	}
}
